module.exports = __webpack_public_path__ + "static/media/no-result-icon.88c2bb35.svg";